var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgPhone = function SvgPhone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2129_11460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23145 10.6053H9.07214V11.4843H8.23145V10.6053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91309 10.6053H10.7538V11.4843H9.91309V10.6053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5498 10.6053H7.3905V11.4843H6.5498V10.6053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0V15H13.3037V0H4ZM9.28241 0.878906L9.04009 1.48705C8.97458 1.65152 8.82216 1.75781 8.65183 1.75781C8.48148 1.75781 8.32909 1.65152 8.26355 1.48705L8.02123 0.878906H9.28241ZM7.11054 0.878906L7.4875 1.82499C7.68394 2.31809 8.141 2.63672 8.65183 2.63672C9.1627 2.63672 9.61972 2.31809 9.81617 1.82499L10.1931 0.878906H12.463V12.3633H4.84069V0.878906H7.11054ZM4.84069 14.1211V13.2422H12.463V14.1211H4.84069Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2129_11460",
    x: 0,
    y: 0,
    width: 17.3037,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2129_11460"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2129_11460",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";